import Helper from '../model/Helper';
import { v3 } from "oc-threejs/short3";
import BaseType from "./BaseType";
import Maths3 from "oc-threejs/Maths3";
import Screens from 'oc-threejs/Screens'

export default class Element extends BaseType(THREE.Group) {

    constructor(vsData) {
        super(vsData);
        this.tapable = true;

        this.tapBox = new THREE.Mesh(
            new THREE.BoxGeometry(1, 1, 1),
            new THREE.MeshBasicMaterial({ color: 0x93b4ed, opacity: 0.2, transparent: true }));
        this.tapBox.visible = false;
        this.visible = false;
        this.add(this.tapBox);

        // const unvmaterial = new THREE.MeshBasicMaterial({color: 0xff0000, opacity: 0.2, transparent: true});
        // const unvgeometry = new THREE.BoxGeometry(1, 1, 1);
        // this.unverdeckt = new THREE.Mesh(unvgeometry,unvmaterial);
        // this.add(this.unverdeckt);
    }

    vsUpdate() {
        this.position.copy(this.vsData.box.getCenter());
        this.quaternion.copy(Maths3.quaternion.zero);

        if (this.isVsChanged('size')) {
            this.tapBox.scale.copy(this.vsData.size).add(v3(0, 0, -5 + this.vsData.getNumberOfParentElements()));
            // this.tapBox.position.copy(this.vsData.size).multiplyScalar(-0.5);
        }
        if (this.isVsChanged('selected')) {
            this.tapBox.visible = this.vsData.selected;
            this.visible = this.vsData.selected;
        }

        // this.unverdeckt.position.copy(this.vsData.unverdeckt.box.getCenter());
        // this.unverdeckt.scale.copy(this.vsData.unverdeckt.box.getSize().sub(v3(1, -20, 1)));
    }

}
